import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function FirmwareAutomation() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Firmware & Device Automation</h1>
        <p>Advanced firmware and device automation for IoT and embedded devices.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Capabilities</h3>
          <ul>
            <li>Automated firmware rollouts</li>
            <li>Device provisioning and orchestration</li>
            <li>OTA updates and rollback strategies</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Discuss Device Solutions</a>
        </div>
      </div>
    </div>
  );
}

export default FirmwareAutomation;
